var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpenNotFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20224_1647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_31_5123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20224_1647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 11C8.55227 11 9 10.5523 9 10C9 9.44773 8.55227 9 8 9C7.44773 9 7 9.44773 7 10C7 10.5523 7.44773 11 8 11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.33333C9.1046 1.33333 10 2.22877 10 3.33333V4.33333H11.3333V3.33333C11.3333 1.49239 9.84093 0 8 0C6.15905 0 4.66667 1.49239 4.66667 3.33333V6L2 6.00002V14H14V6.00002L6 6V3.33333C6 2.22877 6.8954 1.33333 8 1.33333ZM12.6667 7.33333V12.6667H3.33333V7.33333H12.6667Z",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenNotFilled);
export default __webpack_public_path__ + "static/media/lock-open-notFilled.2a5a224100608f16053c2818fc45c068.svg";
export { ForwardRef as ReactComponent };